<template>
    <div>
        <!-- Begin:PageContent -->
        <section id="content">
            <div class="container">
                <div class="row">
                    <!-- Begin:PagePrivacy -->
                    <div id="main" class="col-md-9">
                        <div class="container shortcode travel-ideas">
                            <h1 class="idea-title"><span class="index"><i class="soap-icon-star circle"></i></span>{{ titleinfo[getCurrentLocale] }}:</h1>
                        </div>
                        <br />


                        <!-- Pressmitteilung, 15.06.2020 -->
                        <div class="page">
                            <div class="post-content">
                                <div class="blog-infinite">
                                    <div class="post">
                                        <div class="post-content-wrapper">
                                            <figure class="image-container">
                                                <img src="/res/images/banner-sdr/banner_pressrelease_12.jpg" alt="" />
                                            </figure>
                                            <div class="details">
                                                <h2 class="entry-title">SUNDAIR startet ab Juli wieder zu den schönsten Urlaubszielen</h2>
                                                <br />
                                                <div class="excerpt-container">
                                                    <p>
                                                    <b>Stralsund, 16.06.2020 </b> – Die Flugzeuge der Stralsunder Fluggesellschaft SUNDAIR heben in
                                                    Kürze wieder von ihren Heimatbasen Kassel, Bremen, Dresden sowie Berlin-Tegel zu
                                                    Urlaubszielen am Mittelmeer, dem Schwarzen Meer sowie am Atlantischen Ozean ab.
                                                    Reisende können sich auf die griechische Sonne in den Destinationen Kreta, Kos, Rhodos sowie
                                                    Korfu freuen. Am Schwarzen Meer laden die Strände in Varna und Burgas zur Erholung ein.
                                                    Ebenfalls im neuen Sommerflugplan steht die türkische Riviera mit Antalya. In Spanien bedient
                                                    SUNDAIR die vielfältige Kanareninsel Fuerteventura, sowie die Lieblingsinsel der Deutschen:
                                                    Mallorca. Reisen mit SUNDAIR können im Reisebüro, über Reiseveranstalter sowie über die
                                                    Website <a href="https://www.sundair.com">www.sundair.com</a> gebucht werden.
                                                    <br /> <br />
                                                     <i>„Wir freuen uns darauf unsere Gäste schon bald wieder in ihren wohlverdienten Urlaub
                                                    fliegen zu können. Es war uns wichtig, dass bei der Erstellung des neuen Sommerflugplans
                                                    unseren Passagieren eine breite Vielfalt an Destinationen zur Erholung oder für den
                                                    Aktivurlaub angeboten werden. Wir werden im Laufe des Sommers weitere Ziele des
                                                    ursprünglichen Angebots sowie Erweiterungen von Frequenzen prüfen“ </i>, so Marcos Rossello,
                                                    Geschäftsführer der Sundair GmbH.
                                                    <br /> <br />
                                                    <h3>Schutzmaßnahmen während der gesamten Flugreise</h3>
                                                    Auch in Zeiten von Corona sorgt SUNDAIR dafür, dass alle Gäste sicher in den Urlaub starten.
                                                    Flughäfen und Airlines setzen hierbei eine Reihe von vorbeugenden Schutzmaßnahmen für
                                                    die gesamte Flugreise ein, um diese vom Betreten des Terminals bis zur Ankunft am Zielort so
                                                    sicher wie möglich zu gestalten. An Bord aller SUNDAIR Flüge gilt zunächst für Gäste sowie für
                                                    die Kabinenbesatzungen eine Mund-Nasenschutz-Pflicht. Weiterhin wurden die Ein- und
                                                    Aussteigeprozesse entsprechend der besonderen aktuellen Situation angepasst. Dies
                                                    bedeutet ein Einstieg in kleineren Gruppen und eine erhöhte Anzahl an Bussen. Nach
                                                    Möglichkeit wird ein Einsteigen am Gebäude ermöglicht. Zudem erfolgt eine intensive
                                                    Reinigung der Oberflächen nach den Flügen. Wir bitten unsere Gäste sich während der
                                                    gesamten Reise an die geltenden Hygienevorschriften zu halten und die
                                                    Einreisebestimmungen des jeweiligen Zielorts sowie die Bestimmungen bei der Rückkehr nach
                                                    Deutschland zu beachten.
                                                    </p>


                                                    <br /><b>Zielgebietsübersicht SUNDAIR – Sommer 2020</b><br /><br />
                                                    <table style="width:100%">
                                                        <tr>
                                                            <td><b>Kassel</b></td>
                                                            <td><b>Bremen</b></td>
                                                            <td><b>Dresden</b></td>
                                                            <td><b>Berlin</b></td>
                                                        </tr>
                                                        <tr>
                                                            <td>&nbsp;</td>
                                                            <td>&nbsp;</td>
                                                            <td>&nbsp;</td>
                                                            <td>&nbsp;</td>
                                                        </tr>
                                                        <tr>
                                                            <td>Palma de Mallorca<br />(ab 06. Juli)</td>
                                                            <td>Palma de Mallorca<br />(ab 17. Juli)</td>
                                                            <td>Palma de Mallorca<br />(ab 18. Juli)</td>
                                                            <td>Kreta<br />(ab 04. Juli)</td>
                                                        </tr>
                                                        <tr>
                                                            <td>Kreta<br />(ab 04. Juli)</td>
                                                            <td>Fuerteventura<br />(ab 17. Juli)</td>
                                                            <td>Fuerteventura<br />(ab 23. Juli)</td>
                                                            <td>Kos<br />(ab 02. Juli)</td>
                                                        </tr>
                                                        <tr>
                                                            <td>Antalya<br />(ab 18. Juli)</td>
                                                            <td>Kreta<br />(ab 04. Juli)</td>
                                                            <td>Kreta<br />(ab 12. Juli)</td>
                                                            <td>Rhodos<br />(ab 02. Juli)</td>
                                                        </tr>
                                                        <tr>
                                                            <td>&nbsp;</td>
                                                            <td>Kos<br />(ab 16. Juli)</td>
                                                            <td>Kos<br />(ab 19. Juli)</td>
                                                            <td>Varna<br />(ab 06. Juli)</td>
                                                        </tr>
                                                        <tr>
                                                            <td>&nbsp;</td>
                                                            <td>Rhodos<br />(ab 14. Juli)</td>
                                                            <td>Rhodos<br />(ab 04. Juli)</td>
                                                            <td>Burgas<br />(ab 01. Juli)</td>
                                                        </tr>
                                                        <tr>
                                                            <td>&nbsp;</td>
                                                            <td>Antalya<br />(ab 15. Juli)</td>
                                                            <td>Korfu<br />(ab 21. Juli)</td>
                                                            <td>Beirut<br />(ab 01. Juli)</td>
                                                        </tr>
                                                        <tr>
                                                            <td>&nbsp;</td>
                                                            <td>&nbsp;</td>
                                                            <td>Varna<br />(ab 18. Juli)</td>
                                                            <td>Korfu<br />(ab 04. Juli)</td>
                                                        </tr>
                                                        <tr>
                                                            <td>&nbsp;</td>
                                                            <td>&nbsp;</td>
                                                            <td>Antalya<br />(ab 17. Juli)</td>
                                                            <td>&nbsp;</td>
                                                        </tr>
                                                    </table>
                                                    <br /><p>Ziele vorbehaltlich Änderungen und Beachtung der aktuellen behördlichen Bestimmungen sowie Regularien!</p>

                                                    <br /><br /><p>Kontakt: <a href="mailto:Presse@SUNDAIR.com">Presse@SUNDAIR.com</a></p>
                                                </div>
                                                <div class="post-meta">
                                                    <div class="entry-date">
                                                        <label class="date">15.06.</label>
                                                        <label class="month">2020</label>
                                                    </div>
                                                    <div class="entry-author fn">
                                                        <i class="icon soap-icon-user"></i> Veröffentlicht von:
                                                        <a href="#" class="author">SUNDAIR</a>
                                                    </div>
                                                    <div class="entry-action">
                                                        <span class="entry-tags"><i class="soap-icon-features"></i><span><a href="#">News</a>, <a href="#">Infos</a></span></span>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <!-- <a href="#" class="button btn-large full-width">LOAD MORE POSTS</a> -->
                            </div>
                        </div>


                        <!-- Pressmitteilung, 21.02.2020 -->
                        <div class="page">
                            <div class="post-content">
                                <div class="blog-infinite">
                                    <div class="post">
                                        <div class="post-content-wrapper">
                                            <figure class="image-container">
                                                <img src="/res/images/banner-sdr/banner_pressrelease_11.jpg" alt="" />
                                            </figure>
                                            <div class="details">
                                                <h2 class="entry-title">schauinsland-reisen und SUNDAIR präsentieren den Katta-Flieger</h2>
                                                <br />
                                                <div class="excerpt-container">
                                                    <p>
                                                    <b>Duisburg/Stralsund, 21. Februar 2020</b> – Der neue Flieger der Sundair ist bunt, kindgerecht
                                                    und ein echter Hingucker. Die Rede ist vom Katta-Flieger, der ab Anfang Mai in Bremen
                                                    stationiert sein wird, und Urlauber mit einer ganz besonders auffälligen Maschine nach
                                                    Mallorca, Kreta, Rhodos, Antalya, Fuerteventura und Kos bringen wird. Vorab wird das neue
                                                    Flottenmitglied bereits an anderen Stationen zu Gast sein. Der Airbus A320-214 wurde nach
                                                    der Überführung in den Niederlanden lackiert und in Bremen mit Katta, Ingo Flamingo, Adele
                                                    Garnele und ihren Freunden beklebt. Das Ergebnis: Eine kleine Geschichte, die Urlaubern
                                                    das Warten am Gate verkürzen soll und neugierig macht.

                                                    <br /><br />Katta, der kleine Halbaffe, ist bereits seit einigen Jahren das Maskottchen von schauinslandreisen und der Held der Geschichtsreihe „Kattas Welt“. Die unterhaltsamen Geschichten
                                                    sollen kleine Urlauber zu Weltentdeckern machen und sie für fremde Kulturen und Länder
                                                    begeistern. Vor einem Jahr begeisterte Katta und seine Freunde über 20.000 Besucher beim
                                                    Musical „Katta – Das Kindermusical. Die Reise zur leuchtenden Banane“ und jetzt schicken
                                                    sie ihn sogar in die Luft. <i>„Die Erfolgsgeschichte von ‚Kattas Welt‘ ist einfach unglaublich. Erst
                                                    der Einstieg der Katta CD in die internationalen Albumcharts, dann das eigene
                                                    Animationskonzept mit ‚Katta macht Urlaub‘ und jetzt sorgen wir dafür, dass Katta bereits auf
                                                    dem Flug für Urlaubsfreude sorgt“</i>, so Andreas Rüttgers, Leiter Touristik bei schauinslandreisen.

                                                    <br /><br />Marcos Rossello, Geschäftsführer der Sundair, freut sich über den außergewöhnlichen
                                                    Flottenzuwachs: <i>„Sobald ein Flieger mit besonderer Lackierung ans Gate rollt, zaubert er
                                                    den Passagieren, Besuchern und Flughafenmitarbeitern ein Lächeln ins Gesicht. Von
                                                    diesem positiven Effekt können auch wir als noch junge Airline profitieren und so auf
                                                    charmante Art und Weise unsere Bekanntheit weiter steigern.“</i><br /><br />

                                                    <br /><p>Kontakt: <a href="mailto:Presse@SUNDAIR.com">Presse@SUNDAIR.com</a></p>
                                                </div>
                                                <div class="post-meta">
                                                    <div class="entry-date">
                                                        <label class="date">21.02.</label>
                                                        <label class="month">2020</label>
                                                    </div>
                                                    <div class="entry-author fn">
                                                        <i class="icon soap-icon-user"></i> Veröffentlicht von:
                                                        <a href="#" class="author">SUNDAIR</a>
                                                    </div>
                                                    <div class="entry-action">
                                                        <span class="entry-tags"><i class="soap-icon-features"></i><span><a href="#">News</a>, <a href="#">Infos</a></span></span>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <!-- <a href="#" class="button btn-large full-width">LOAD MORE POSTS</a> -->
                            </div>
                        </div>


                        <!-- Pressmitteilung, 18.11.2019 -->
                        <div class="page">
                            <div class="post-content">
                                <div class="blog-infinite">
                                    <div class="post">
                                        <div class="post-content-wrapper">
                                            <figure class="image-container">
                                                <img src="/res/images/banner-sdr/banner_pressrelease_10.jpg" alt="" />
                                            </figure>
                                            <div class="details">
                                                <h2 class="entry-title">Nonstop nach Korfu: SUNDAIR erweitert Angebot am Flughafen Dresden</h2>
                                                <br />
                                                <div class="excerpt-container">
                                                    <p>
                                                    <b>Stralsund, 18.22.2019 </b> – In der kommenden Sommersaison stockt die Fluggesellschaft SUNDAIR ihr Angebot ab Dresden auf und fliegt nun auch nach Korfu.
                                                    Vom 5. Mai bis 27. Oktober 2020 bringt die Airline immer dienstags Urlauber auf die sonnenreiche Insel vor der griechischen Nordwestküste.
                                                    Für das neue Ziel sind bereits Pauschalreisen buchbar. Flugtickets erhalten Erholungssuchende demnächst auf <a href="https://www.sundair.com">www.sundair.com</a>.
                                                    <br /> <br />
                                                    <i>„Mit Korfu erweitern wir im Sommer 2020 unser Streckenetz ab Dresden um eine weitere attraktive griechische Destination.
                                                    Jeden Dienstag bringt unsere SUNDAIR-Maschine Reisende aus Sachsen und der Umgebung nach Korfu. Wir freuen uns, dass wir neben Rhodos, Kos und Heraklion ab dem nächsten Sommerflugplan vier Ziele auf den griechischen Inseln anfliegen werden“,</i>
                                                    so Marcos Rossello, Geschäftsführer von SUNDAIR.
                                                    <br /><br />
                                                    SUNDAIR steuert im Sommerflugplan 2020 insgesamt neun Ziele von Dresden an. Am Airport der sächsischen Landeshauptstadt werden deshalb zwei Flugzeuge vom Typ A320 stationiert.
                                                    <br /><br />
                                                    Im aktuellen Winterflugplan hebt die Fluggesellschaft nach Fuerteventura, Gran Canaria und Teneriffa ab. Mit Hurghada und Marsa Alam haben Erholungssuchende zudem zwei sonnenreiche Alternativen, die mit SUNDAIR ab Dresden nonstop erreichbar sind.
                                                    <br /><br />
                                                    Götz Ahmelmann, Vorstandsvorsitzender der Mitteldeutschen Flughafen AG, betont: <i>„Erst im Mai dieses Jahres hat SUNDAIR eine Basis am Flughafen Dresden eröffnet und wird mit einem weiteren hier stationierten Airbus sein Engagement ausbauen.
                                                    Es freut uns sehr, dass Korfu nun ein schnelles Comeback im Dresdner Flugplan erlebt und damit auch im Sommer 2020 eines der beliebtesten griechischen Urlaubsziele nonstop erreichbar ist.”<i>


                                                    <br /><br /><b>SUNDAIR-Verbindungen ab Dresden in der Wintersaison 2019/20</b><br />
                                                    <table style="width:100%">
                                                        <tr>
                                                            <td>04.11.2019</td>
                                                            <td>20.04.2020</td>
                                                            <td>Montag</td>
                                                            <td>Fuerteventura</td>
                                                        </tr>
                                                        <tr>
                                                            <td>03.11.2019</td>
                                                            <td>26.04.2020</td>
                                                            <td>Sonntag</td>
                                                            <td>Gran Canaria</td>
                                                        </tr>
                                                        <tr>
                                                            <td>&nbsp;</td>
                                                            <td>&nbsp;</td>
                                                            <td>&nbsp;</td>
                                                            <td>&nbsp;</td>
                                                        </tr>
                                                        <tr>
                                                            <td>
                                                                05.11.2019<br/>
                                                                07.11.2019<br/>
                                                                02.11.2019
                                                            </td>
                                                            <td>
                                                                28.04.2020<br/>
                                                                30.04.2020<br/>
                                                                18.04.2020
                                                            </td>
                                                            <td>
                                                                Dienstag<br/>
                                                                Donnerstag<br/>
                                                                Samstag
                                                            </td>
                                                            <td style="vertical-align: text-top;">Hurghada</td>
                                                        </tr>
                                                        <tr>
                                                            <td>&nbsp;</td>
                                                            <td>&nbsp;</td>
                                                            <td>&nbsp;</td>
                                                            <td>&nbsp;</td>
                                                        </tr>
                                                        <tr>
                                                            <td>07.02.2020</td>
                                                            <td>17.04.2020</td>
                                                            <td>Freitag</td>
                                                            <td>Marsa Alam</td>
                                                        </tr>
                                                        <tr>
                                                            <td>06.11.2019</td>
                                                            <td>15.04.2020</td>
                                                            <td>Mittwoch</td>
                                                            <td>Teneriffa</td>
                                                        </tr>
                                                    </table><br />


                                                    <br /><br /><b>SUNDAIR-Verbindungen ab Dresden in der Sommersaison 2020</b><br /><br />
                                                    <table style="width:100%">
                                                        <tr>
                                                            <td>
                                                                05.05.2020<br />
                                                                01.05.2020<br />
                                                                03.05.2020
                                                            </td>
                                                            <td>
                                                                27.10.2020<br />
                                                                30.10.2020<br />
                                                                01.11.2020
                                                            </td>
                                                            <td>
                                                                Dienstag<br />
                                                                Freitag<br />
                                                                Sonntag
                                                            </td>
                                                            <td style="vertical-align: text-top;">Antalya</td>
                                                        </tr>
                                                        <tr>
                                                            <td>&nbsp;</td>
                                                            <td>&nbsp;</td>
                                                            <td>&nbsp;</td>
                                                            <td>&nbsp;</td>
                                                        </tr>
                                                        <tr>
                                                            <td>
                                                                07.05.2020
                                                            </td>
                                                            <td>
                                                                29.10.2020
                                                            </td>
                                                            <td>
                                                                Donnerstag
                                                            </td>
                                                            <td style="vertical-align: text-top;">Fuerteventura</td>
                                                        </tr>
                                                        <tr>
                                                            <td>&nbsp;</td>
                                                            <td>&nbsp;</td>
                                                            <td>&nbsp;</td>
                                                            <td>&nbsp;</td>
                                                        </tr>
                                                        <tr>
                                                            <td>
                                                                04.05.2020<br />
                                                                06.05.2020<br />
                                                                01.05.2020<br />
                                                                03.05.2020
                                                            </td>
                                                            <td>
                                                                26.10.2020<br />
                                                                28.10.2020<br />
                                                                30.10.2020<br />
                                                                01.11.2020
                                                            </td>
                                                            <td>
                                                                Montag<br />
                                                                Mittwoch<br />
                                                                Freitag<br />
                                                                Sonntag
                                                            </td>
                                                            <td style="vertical-align: text-top;">Heraklion (Kreta)</td>
                                                        </tr>
                                                        <tr>
                                                            <td>&nbsp;</td>
                                                            <td>&nbsp;</td>
                                                            <td>&nbsp;</td>
                                                            <td>&nbsp;</td>
                                                        </tr>
                                                        <tr>
                                                            <td>
                                                                05.05.2020<br />
                                                                02.05.2020
                                                            </td>
                                                            <td>
                                                                27.10.2020<br />
                                                                31.10.2020
                                                            </td>
                                                            <td>
                                                                Dienstag<br />
                                                                Samstag
                                                            </td>
                                                            <td style="vertical-align: text-top;">Hurghada</td>
                                                        </tr>
                                                        <tr>
                                                            <td>&nbsp;</td>
                                                            <td>&nbsp;</td>
                                                            <td>&nbsp;</td>
                                                            <td>&nbsp;</td>
                                                        </tr>
                                                        <tr>
                                                            <td>
                                                                07.05.2020
                                                            </td>
                                                            <td>
                                                                27.10.2020
                                                            </td>
                                                            <td>
                                                                Dienstag
                                                            </td>
                                                            <td style="vertical-align: text-top;">Korfu</td>
                                                        </tr>
                                                        <tr>
                                                            <td>&nbsp;</td>
                                                            <td>&nbsp;</td>
                                                            <td>&nbsp;</td>
                                                            <td>&nbsp;</td>
                                                        </tr>
                                                        <tr>
                                                            <td>
                                                                07.05.2020<br />
                                                                03.05.2020
                                                            </td>
                                                            <td>
                                                                29.10.2020<br />
                                                                01.11.2020
                                                            </td>
                                                            <td>
                                                                Donnerstag<br />
                                                                Sonntag
                                                            </td>
                                                            <td style="vertical-align: text-top;">Kos</td>
                                                        </tr>
                                                        <tr>
                                                            <td>&nbsp;</td>
                                                            <td>&nbsp;</td>
                                                            <td>&nbsp;</td>
                                                            <td>&nbsp;</td>
                                                        </tr>
                                                        <tr>
                                                            <td>
                                                                05.05.2020<br />
                                                                07.05.2020<br />
                                                                02.05.2020
                                                            </td>
                                                            <td>
                                                                27.10.2020<br />
                                                                29.10.2020<br />
                                                                31.10.2020
                                                            </td>
                                                            <td>
                                                                Dienstag<br />
                                                                Donnerstag<br />
                                                                Samstag
                                                            </td>
                                                            <td style="vertical-align: text-top;">Palma de Mallorca</td>
                                                        </tr>
                                                        <tr>
                                                            <td>&nbsp;</td>
                                                            <td>&nbsp;</td>
                                                            <td>&nbsp;</td>
                                                            <td>&nbsp;</td>
                                                        </tr>
                                                        <tr>
                                                            <td>
                                                                05.05.2020<br />
                                                                07.05.2020<br />
                                                                02.05.2020
                                                            </td>
                                                            <td>
                                                                27.10.2020<br />
                                                                29.10.2020<br />
                                                                31.10.2020
                                                            </td>
                                                            <td>
                                                                Dienstag<br />
                                                                Donnerstag<br />
                                                                Samstag
                                                            </td>
                                                            <td style="vertical-align: text-top;">Rhodos</td>
                                                        </tr>
                                                        <tr>
                                                            <td>&nbsp;</td>
                                                            <td>&nbsp;</td>
                                                            <td>&nbsp;</td>
                                                            <td>&nbsp;</td>
                                                        </tr>
                                                        <tr>
                                                            <td>
                                                                18.05.2020<br />
                                                                06.06.2020
                                                            </td>
                                                            <td>
                                                                24.08.2020<br />
                                                                26.09.2020
                                                            </td>
                                                            <td>
                                                                Montag<br />
                                                                Samstag
                                                            </td>
                                                            <td style="vertical-align: text-top;">Varna (Bulgarien)</td>
                                                        </tr>
                                                    </table><br />


                                                    <br /><p>Kontakt: <a href="mailto:Presse@SUNDAIR.com">Presse@SUNDAIR.com</a></p>
                                                </div>
                                                <div class="post-meta">
                                                    <div class="entry-date">
                                                        <label class="date">18.11.</label>
                                                        <label class="month">2019</label>
                                                    </div>
                                                    <div class="entry-author fn">
                                                        <i class="icon soap-icon-user"></i> Veröffentlicht von:
                                                        <a href="#" class="author">SUNDAIR</a>
                                                    </div>
                                                    <div class="entry-action">
                                                        <span class="entry-tags"><i class="soap-icon-features"></i><span><a href="#">News</a>, <a href="#">Infos</a></span></span>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <!-- <a href="#" class="button btn-large full-width">LOAD MORE POSTS</a> -->
                            </div>
                        </div>


                        <!-- Pressmitteilung, 06.09.2019 -->
                        <div class="page">
                            <div class="post-content">
                                <div class="blog-infinite">
                                    <div class="post">
                                        <div class="post-content-wrapper">
                                            <figure class="image-container">
                                                <img src="/res/images/banner-sdr/banner_pressrelease_9.jpg" alt="" />
                                            </figure>
                                            <div class="details">
                                                <h2 class="entry-title">SUNDAIR mit Zusatzprogramm ab Düsseldorf</h2>
                                                <br />
                                                <div class="excerpt-container">
                                                    <p>
                                                    <b>Stralsund, 06.09.2019 </b> – Auch in diesem Jahr startet SUNDAIR über Weihnachten und Silvester
                                                    ein Zusatzprogramm ab Düsseldorf. Reisende können aus der Hauptstadt Nordrhein-Westfalens mit SUNDAIR nach Fuerteventura, Gran Canaria und Teneriffa auf den Kanarischen
                                                    Inseln aufbrechen. Die Inseln des ewigen Frühlings erwarten die Urlaubsgäste mit
                                                    angenehmen Temperaturen, langen Sandstränden sowie abwechslungsreicher Natur und
                                                    bieten den idealen Ausgangspunkt für den Erholungs- oder Aktivurlaub. Im Zeitraum vom
                                                    21.12.2019 bis einschließlich 05.01.2020 wird die Stralsunder Airline für das Zusatzprogramm
                                                    einen A320 am Flughafen Düsseldorf stationieren. Insgesamt startet SUNDAIR im Zeitraum des
                                                    Zusatzprogramms zu 11 Abflügen in Düsseldorf. Neben drei tollen Destinationen können sich
                                                    die Urlaubsgäste mit SUNDAIR auf eine zuverlässige Airline, 20 kg Freigepäck sowie sehr guten
                                                    Service an Bord freuen.<br /><br />

                                                    Alle Termine sind bereits im Reisebüro oder unter <a href="https://www.sundair.com">www.sundair.com</a> buchbar.<br /><br />

                                                    <br /><p>Kontakt: <a href="mailto:Presse@SUNDAIR.com">Presse@SUNDAIR.com</a></p>
                                                </div>
                                                <div class="post-meta">
                                                    <div class="entry-date">
                                                        <label class="date">06.09.</label>
                                                        <label class="month">2019</label>
                                                    </div>
                                                    <div class="entry-author fn">
                                                        <i class="icon soap-icon-user"></i> Veröffentlicht von:
                                                        <a href="#" class="author">SUNDAIR</a>
                                                    </div>
                                                    <div class="entry-action">
                                                        <span class="entry-tags"><i class="soap-icon-features"></i><span><a href="#">News</a>, <a href="#">Infos</a></span></span>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <!-- <a href="#" class="button btn-large full-width">LOAD MORE POSTS</a> -->
                            </div>
                        </div>


                        <!-- Pressmitteilung, 23.08.2019 -->
                        <div class="page">
                            <div class="post-content">
                                <div class="blog-infinite">
                                    <div class="post">
                                        <div class="post-content-wrapper">
                                            <figure class="image-container">
                                                <img src="/res/images/banner-sdr/banner_pressrelease_7.jpg" alt="" />
                                            </figure>
                                            <div class="details">
                                                <h2 class="entry-title">Mehr Urlaubsflüge und neue Strecken: SUNDAIR baut Angebot ab Dresden aus</h2>
                                                <br />
                                                <div class="excerpt-container">
                                                    <p>
                                                    <b>Stralsund, 23.08.2019 </b> – Die Fluggesellschaft SUNDAIR verstärkt ihr Engagement am Flughafen
                                                    Dresden. Im Sommer 2020 stationiert die Airline ein zweites
                                                    Flugzeug und steuert auch Palma de Mallorca und Varna an.
                                                    Außerdem stehen erstmals die Urlaubsziele Fuerteventura und
                                                    Hurghada im Sommerflugplan. Erholungssuchende können des
                                                    Weiteren nach Antalya, Heraklion, Kos und Rhodos fliegen. Dadurch
                                                    steigt die Anzahl der wöchentlichen Starts und Landungen von
                                                    SUNDAIR am Dresdner Airport von 28 auf 40. Für die zusätzlichen
                                                    Flüge kommt ein Airbus A320 zum Einsatz. Die neuen Angebote sind
                                                    bereits buchbar. </b><br /><br />

                                                    <i>“Mit neuen Zielen und der Stationierung einer zweiten Maschine am
                                                    Standort Dresden, erweitern wir die Angebotsvielfalt für unsere Passagiere.
                                                    Mit SUNDAIR bieten wir den Reisenden eine zuverlässige Airline mit sehr
                                                    gutem Service. Wir freuen uns bereits jetzt auf die kommende
                                                    Sommersaison in Dresden und auf viele zufriedene Gäste”</i>, so Marcos
                                                    Rossello, Geschäftsführer der SUNDAIR.<br /><br />

                                                    Götz Ahmelmann, Vorstandsvorsitzender der Mitteldeutschen Flughafen
                                                    AG, betont: <i>“Im Einzugsgebiet des Flughafens Dresden gibt es eine große
                                                    Nachfrage nach touristischen Flügen. Wir freuen uns, dass SUNDAIR dieses
                                                    Potenzial nutzt und an unserem Standort die Angebote bereits wenige
                                                    Monate nach der Basis-Eröffnung ausbaut. Für Urlauber ergibt sich dadurch
                                                    eine größere Auswahl an Zielen sowie eine flexiblere Reiseplanung.”</i><br /><br />

                                                    Anfang Mai 2019 eröffnete SUNDAIR eine Basis am Flughafen Dresden und
                                                    stationierte einen Airbus A320. Damit bringt die Airline aktuell jede Woche
                                                    Passagiere nach Heraklion, Rhodos, Kos und Antalya.<br /><br />

                                                    Im Winterflugplan, der Ende Oktober beginnt, steuert die Fluggesellschaft
                                                    Fuerteventura, Gran Canaria und Teneriffa an. Mit Hurghada und Marsa
                                                    Alam haben Erholungssuchende zudem zwei sonnenreiche Alternativen, die
                                                    mit SUNDAIR ab Dresden nonstop erreichbar sind.<br /><br />

                                                    <br /><b>SUNDAIR-Verbindungen ab Dresden in der Wintersaison 2019/20</b><br />
                                                    <table style="width:100%">
                                                        <tr>
                                                            <td>04.11.2019</td>
                                                            <td>20.04.2020</td>
                                                            <td>Montag</td>
                                                            <td>Fuerteventura</td>
                                                        </tr>
                                                        <tr>
                                                            <td>03.11.2019</td>
                                                            <td>26.04.2020</td>
                                                            <td>Sonntag</td>
                                                            <td>Gran Canaria</td>
                                                        </tr>
                                                        <tr>
                                                            <td>&nbsp;</td>
                                                            <td>&nbsp;</td>
                                                            <td>&nbsp;</td>
                                                            <td>&nbsp;</td>
                                                        </tr>
                                                        <tr>
                                                            <td>
                                                                05.11.2019<br/>
                                                                07.11.2019<br/>
                                                                02.11.2019
                                                            </td>
                                                            <td>
                                                                28.04.2020<br/>
                                                                30.04.2020<br/>
                                                                18.04.2020
                                                            </td>
                                                            <td>
                                                                Dienstag<br/>
                                                                Donnerstag<br/>
                                                                Samstag
                                                            </td>
                                                            <td style="vertical-align: text-top;">Hurghada</td>
                                                        </tr>
                                                        <tr>
                                                            <td>&nbsp;</td>
                                                            <td>&nbsp;</td>
                                                            <td>&nbsp;</td>
                                                            <td>&nbsp;</td>
                                                        </tr>
                                                        <tr>
                                                            <td>07.02.2020</td>
                                                            <td>17.04.2020</td>
                                                            <td>Freitag</td>
                                                            <td>Marsa Alam</td>
                                                        </tr>
                                                        <tr>
                                                            <td>06.11.2019</td>
                                                            <td>15.04.2020</td>
                                                            <td>Mittwoch</td>
                                                            <td>Teneriffa</td>
                                                        </tr>
                                                    </table><br />


                                                    <br /><br /><b>SUNDAIR-Verbindungen ab Dresden in der Sommersaison 2020</b><br /><br />
                                                    <table style="width:100%">
                                                        <tr>
                                                            <td>
                                                                05.05.2020<br />
                                                                01.05.2020<br />
                                                                03.05.2020
                                                            </td>
                                                            <td>
                                                                27.10.2020<br />
                                                                30.10.2020<br />
                                                                01.11.2020
                                                            </td>
                                                            <td>
                                                                Dienstag<br />
                                                                Freitag<br />
                                                                Sonntag
                                                            </td>
                                                            <td style="vertical-align: text-top;">Antalya</td>
                                                        </tr>
                                                        <tr>
                                                            <td>&nbsp;</td>
                                                            <td>&nbsp;</td>
                                                            <td>&nbsp;</td>
                                                            <td>&nbsp;</td>
                                                        </tr>
                                                        <tr>
                                                            <td>
                                                                07.05.2020
                                                            </td>
                                                            <td>
                                                                29.10.2020
                                                            </td>
                                                            <td>
                                                                Donnerstag
                                                            </td>
                                                            <td style="vertical-align: text-top;">Fuerteventura</td>
                                                        </tr>
                                                        <tr>
                                                            <td>&nbsp;</td>
                                                            <td>&nbsp;</td>
                                                            <td>&nbsp;</td>
                                                            <td>&nbsp;</td>
                                                        </tr>
                                                        <tr>
                                                            <td>
                                                                04.05.2020<br />
                                                                06.05.2020<br />
                                                                01.05.2020<br />
                                                                03.05.2020
                                                            </td>
                                                            <td>
                                                                26.10.2020<br />
                                                                28.10.2020<br />
                                                                30.10.2020<br />
                                                                01.11.2020
                                                            </td>
                                                            <td>
                                                                Montag<br />
                                                                Mittwoch<br />
                                                                Freitag<br />
                                                                Sonntag
                                                            </td>
                                                            <td style="vertical-align: text-top;">Heraklion (Kreta)</td>
                                                        </tr>
                                                        <tr>
                                                            <td>&nbsp;</td>
                                                            <td>&nbsp;</td>
                                                            <td>&nbsp;</td>
                                                            <td>&nbsp;</td>
                                                        </tr>
                                                        <tr>
                                                            <td>
                                                                05.05.2020<br />
                                                                02.05.2020
                                                            </td>
                                                            <td>
                                                                27.10.2020<br />
                                                                31.10.2020
                                                            </td>
                                                            <td>
                                                                Dienstag<br />
                                                                Samstag
                                                            </td>
                                                            <td style="vertical-align: text-top;">Hurghada</td>
                                                        </tr>
                                                        <tr>
                                                            <td>&nbsp;</td>
                                                            <td>&nbsp;</td>
                                                            <td>&nbsp;</td>
                                                            <td>&nbsp;</td>
                                                        </tr>
                                                        <tr>
                                                            <td>
                                                                07.05.2020<br />
                                                                03.05.2020
                                                            </td>
                                                            <td>
                                                                29.10.2020<br />
                                                                01.11.2020
                                                            </td>
                                                            <td>
                                                                Donnerstag<br />
                                                                Sonntag
                                                            </td>
                                                            <td style="vertical-align: text-top;">Kos</td>
                                                        </tr>
                                                        <tr>
                                                            <td>&nbsp;</td>
                                                            <td>&nbsp;</td>
                                                            <td>&nbsp;</td>
                                                            <td>&nbsp;</td>
                                                        </tr>
                                                        <tr>
                                                            <td>
                                                                05.05.2020<br />
                                                                07.05.2020<br />
                                                                02.05.2020
                                                            </td>
                                                            <td>
                                                                27.10.2020<br />
                                                                29.10.2020<br />
                                                                31.10.2020
                                                            </td>
                                                            <td>
                                                                Dienstag<br />
                                                                Donnerstag<br />
                                                                Samstag
                                                            </td>
                                                            <td style="vertical-align: text-top;">Palma de Mallorca</td>
                                                        </tr>
                                                        <tr>
                                                            <td>&nbsp;</td>
                                                            <td>&nbsp;</td>
                                                            <td>&nbsp;</td>
                                                            <td>&nbsp;</td>
                                                        </tr>
                                                        <tr>
                                                            <td>
                                                                05.05.2020<br />
                                                                07.05.2020<br />
                                                                02.05.2020
                                                            </td>
                                                            <td>
                                                                27.10.2020<br />
                                                                29.10.2020<br />
                                                                31.10.2020
                                                            </td>
                                                            <td>
                                                                Dienstag<br />
                                                                Donnerstag<br />
                                                                Samstag
                                                            </td>
                                                            <td style="vertical-align: text-top;">Rhodos</td>
                                                        </tr>
                                                        <tr>
                                                            <td>&nbsp;</td>
                                                            <td>&nbsp;</td>
                                                            <td>&nbsp;</td>
                                                            <td>&nbsp;</td>
                                                        </tr>
                                                        <tr>
                                                            <td>
                                                                18.05.2020<br />
                                                                06.06.2020
                                                            </td>
                                                            <td>
                                                                24.08.2020<br />
                                                                26.09.2020
                                                            </td>
                                                            <td>
                                                                Montag<br />
                                                                Samstag
                                                            </td>
                                                            <td style="vertical-align: text-top;">Varna (Bulgarien)</td>
                                                        </tr>
                                                    </table><br />

                                                    <br /><p>Kontakt: <a href="mailto:Presse@SUNDAIR.com">Presse@SUNDAIR.com</a></p>
                                                </div>
                                                <div class="post-meta">
                                                    <div class="entry-date">
                                                        <label class="date">23.08.</label>
                                                        <label class="month">2019</label>
                                                    </div>
                                                    <div class="entry-author fn">
                                                        <i class="icon soap-icon-user"></i> Veröffentlicht von:
                                                        <a href="#" class="author">SUNDAIR</a>
                                                    </div>
                                                    <div class="entry-action">
                                                        <span class="entry-tags"><i class="soap-icon-features"></i><span><a href="#">News</a>, <a href="#">Infos</a></span></span>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <!-- <a href="#" class="button btn-large full-width">LOAD MORE POSTS</a> -->
                            </div>
                        </div>


                        <!-- Pressmitteilung, 15.08.2019 -->
                        <div class="page">
                            <div class="post-content">
                                <div class="blog-infinite">
                                    <div class="post">
                                        <div class="post-content-wrapper">
                                            <figure class="image-container">
                                                <img src="/res/images/banner-sdr/banner_pressrelease_8.jpg" alt="" />
                                            </figure>
                                            <div class="details">
                                                <h2 class="entry-title">SUNDAIR präsentiert Sommerziele 2020 ab Bremen-Airport</h2>
                                                <br />
                                                <div class="excerpt-container">
                                                    <p>
                                                    <b>Stralsund, 15.08.2019 </b> – Gut zwei Wochen vor dem Erstflug und der Stationseröffnung in
                                                    Bremen, präsentiert die Stralsunder Airline SUNDAIR ihren Sommerflugplan ab Bremen-Airport.
                                                    Mit Zielen rund um das westliche sowie östliche Mittelmeer und am Atlantischen Ozean, bietet
                                                    die junge Airline Urlaubern eine breite Vielfalt an Möglicheiten für die Reiseplanung. Mit vier
                                                    wöchentlichen Abflügen (montags, mittwochs, freitags und sonntags) bringt SUNDAIR Reisende
                                                    aus Bremen und der Region direkt auf die beliebteste deutsche Baleareninsel, Palma de
                                                    Mallorca. Im östlichen Mittelmeer bedient SUNDAIR mit Heraklion auf Kreta, den griechischen
                                                    Inseln Rhodos und Kos, sowie auch Antalya in der Türkei insgesamt vier Ziele in zwei Ländern.
                                                    Die Urlaubsgäste erreichen die größte Ferieninsel Griechenlands Kreta dreimal wöchentlich
                                                    mit SUNDAIR ab Bremen. Jeden Dienstag und Samstag hebt der SUNDAIR Airbus A320 ebenfalls
                                                    in Richtung der Sonneninsel Rhodos ab. Auch die schöne griechische Destination Kos wird ab
                                                    Mai 2020 wöchentlich mit zwei Abflügen durch die Stralsunder Airline vom norddeutschen
                                                    Bremen-Airport angeboten. Abgerundet wird das Destinationsportfolio im östlichen Mittelmeer
                                                    von Antalya in der Türkei mit jeweils einem wöchentlichen Flug. Ebenfalls im Programm findet
                                                    sich auch die Kanarische Insel Fuerteventura, welche Reisende jeweils montags und freitags
                                                    direkt von Bremen aus erreichen.  </b><br /><br />

                                                    <i>„Wir freuen uns auf unsere erste ganzheitliche Sommersaison ab Bremen und bieten den
                                                    Reisenden ein vielfältiges Portfolio an Destinationen für ihren Urlaub. Dazu können sich die
                                                    Bremerinnen und Bremer auf eine zuverlässige Airline, guten Service, sowie 20kg Freigepäck
                                                    freuen“</i>, so Marcos Rossello, Geschäftsführer der SUNDAIR.<br /><br />

                                                    Und Flughafen-Chef Elmar Kleinert ergänzt: <i>„SUNDAIR fliegt kommenden Sommer ab Bremen
                                                    sechs Ziele in beliebten Urlaubsregionen an, von Antalya bis Rhodos sind hier tolle
                                                    Destinationen im Programm. Wir hoffen, dass aus diesen gelungenen Anfängen eine
                                                    langjährige und starke Partnerschaft zwischen SUNDAIR und Bremen Airport entsteht.“</i><br /><br />

                                                    <br /><b>SUNDAIR Sommerflugplan 2020 ab Bremen Airport </b><br />
                                                    <table style="width:100%">
                                                        <tr>
                                                            <td>04.05.2020</td>
                                                            <td>26.10.2020</td>
                                                            <td>Montag</td>
                                                            <td>
                                                                Bremen – Palma de Mallorca - Bremen<br />
                                                                Bremen – Fuerteventura - Bremen
                                                            </td>
                                                        </tr>
                                                        <tr>
                                                            <td>&nbsp;</td>
                                                            <td>&nbsp;</td>
                                                            <td>&nbsp;</td>
                                                            <td>&nbsp;</td>
                                                        </tr>
                                                        <tr>
                                                            <td>05.05.2020</td>
                                                            <td>27.10.2020</td>
                                                            <td>Dienstag</td>
                                                            <td>
                                                                Bremen – Heraklion – Bremen<br />
                                                                Bremen – Rhodos - Bremen
                                                            </td>
                                                        </tr>
                                                        <tr>
                                                            <td>&nbsp;</td>
                                                            <td>&nbsp;</td>
                                                            <td>&nbsp;</td>
                                                            <td>&nbsp;</td>
                                                        </tr>
                                                        <tr>
                                                            <td>06.05.2020</td>
                                                            <td>28.10.2020</td>
                                                            <td>Mittwoch</td>
                                                            <td>
                                                                Bremen – Palma de Mallorca – Bremen<br />
                                                                Bremen – Kos – Bremen
                                                            </td>
                                                        </tr>
                                                        <tr>
                                                            <td>&nbsp;</td>
                                                            <td>&nbsp;</td>
                                                            <td>&nbsp;</td>
                                                            <td>&nbsp;</td>
                                                        </tr>
                                                        <tr>
                                                            <td>07.05.2020 </td>
                                                            <td>29.10.2020 </td>
                                                            <td>Donnerstag</td>
                                                            <td>
                                                                Bremen – Heraklion – Bremen<br />
                                                                Bremen – Antalya – Bremen
                                                            </td>
                                                        </tr>
                                                        <tr>
                                                            <td>&nbsp;</td>
                                                            <td>&nbsp;</td>
                                                            <td>&nbsp;</td>
                                                            <td>&nbsp;</td>
                                                        </tr>
                                                        <tr>
                                                            <td>01.05.2020  </td>
                                                            <td>30.10.2020 </td>
                                                            <td>Freitag</td>
                                                            <td>
                                                                Bremen – Palma de Mallorca – Bremen<br />
                                                                Bremen – Fuerteventura – Bremen
                                                            </td>
                                                        </tr>
                                                        <tr>
                                                            <td>&nbsp;</td>
                                                            <td>&nbsp;</td>
                                                            <td>&nbsp;</td>
                                                            <td>&nbsp;</td>
                                                        </tr>
                                                        <tr>
                                                            <td>02.05.2020</td>
                                                            <td>31.10.2020 </td>
                                                            <td>Samstag</td>
                                                            <td>
                                                                Bremen – Heraklion – Bremen<br />
                                                                Bremen – Rhodos – Bremen
                                                            </td>
                                                        </tr>
                                                        <tr>
                                                            <td>&nbsp;</td>
                                                            <td>&nbsp;</td>
                                                            <td>&nbsp;</td>
                                                            <td>&nbsp;</td>
                                                        </tr>
                                                        <tr>
                                                            <td>03.05.2020</td>
                                                            <td>25.10.2020</td>
                                                            <td>Sonntag</td>
                                                            <td>
                                                                Bremen – Palma de Mallorca – Bremen<br />
                                                                Bremen – Kos - Bremen
                                                            </td>
                                                        </tr>
                                                    </table><br />


                                                    <br /><p>Kontakt: <a href="mailto:Presse@SUNDAIR.com">Presse@SUNDAIR.com</a></p>
                                                </div>
                                                <div class="post-meta">
                                                    <div class="entry-date">
                                                        <label class="date">15.08.</label>
                                                        <label class="month">2019</label>
                                                    </div>
                                                    <div class="entry-author fn">
                                                        <i class="icon soap-icon-user"></i> Veröffentlicht von:
                                                        <a href="#" class="author">SUNDAIR</a>
                                                    </div>
                                                    <div class="entry-action">
                                                        <span class="entry-tags"><i class="soap-icon-features"></i><span><a href="#">News</a>, <a href="#">Infos</a></span></span>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <!-- <a href="#" class="button btn-large full-width">LOAD MORE POSTS</a> -->
                            </div>
                        </div>


                        <!-- Pressmitteilung,09.08.2019 -->
                        <div class="page">
                            <div class="post-content">
                                <div class="blog-infinite">
                                    <div class="post">
                                        <div class="post-content-wrapper">
                                            <figure class="image-container">
                                                <img src="/res/images/banner-sdr/banner_pressrelease_6.jpg" alt="" />
                                            </figure>
                                            <div class="details">
                                                <h2 class="entry-title">SUNDAIR veröffentlicht Sommerflugplan 2020 ab Kassel</h2>
                                                <br />
                                                <div class="excerpt-container">
                                                    <p>
                                                    <b>Stralsund, 09.08.2019 </b> – – Noch während des aktuell laufenden Sommerflugplans präsentiert die
                                                    junge Stralsunder Airline ihre Sonnenstrecken für den Sommer 2020. Mit diesem Angebot
                                                    bietet SUNDAIR nunmehr in der dritten Sommersaison Reisenden aus Kassel und der Region
                                                    die Möglichkeit, direkt von Zuhause in den Urlaub zu starten. Mit Destinationen am Mittelmeer,
                                                    an dem Roten Meer sowie am Atlantischen Ozean, können Urlauber aus einer breiten Vielfalt
                                                    an Möglichkeiten für ihren Sommerurlaub wählen. Mit vier wöchentlichen Abflügen (montags,
                                                    mittwochs, freitags und sonntags) bringt SUNDAIR ihre Gäste direkt auf die beliebteste deutsche
                                                    Ferieninsel, Palma de Mallorca. Auch die bekannten griechischen Urlaubsziele Rhodos und
                                                    Heraklion werden von SUNDAIR im nächsten Sommerprogramm ab Kassel bedient. Reisende
                                                    erreichen die größte Insel Griechenlands, Kreta, jeweils zweimal wöchentlich, dienstags und
                                                    samstags. Jeden Donnerstag verbindet SUNDAIR die Sonneninsel Rhodos direkt mit Kassel. Mit
                                                    Hurghada in Ägypten bietet die Stralsunder Airline ein weiteres interessantes Reiseziel,
                                                    welches Urlauber mit seinen durchgehend sommerlichen Temperaturen als Bade- und
                                                    Tauchparadies erwartet. Mit SUNDAIR geht es ab Mai 2020 immer donnerstags von Kassel nach
                                                    Hurghada. Ebenfalls in der Routenvielfalt der Airline findet sich die Kanarische Insel
                                                    Fuerteventura, welche Reisende immer freitags ab Kassel erreichen können.<br /><br />

                                                    <i>„Der Sommerflugplan bietet unseren Gästen ab Kassel wieder einmal zahlreiche
                                                    Möglichkeiten für Ihren Urlaub: Von Aktivurlaub bis Erholung am Strand. Dazu können sich
                                                    unsere Gäste auf den gewohnt guten SUNDAIR-Service freuen und entspannt in ihren Urlaub
                                                    starten“</i>, so Marcos Rossello, Geschäftsführer der SUNDAIR.<br /><br />


                                                    <br /><b>SUNDAIR Sommerflugplan 2020 ab Kassel-Airport:</b><br />
                                                    <table style="width:100%">
                                                        <tr>
                                                            <td>04.05.2020</td>
                                                            <td>19.10.2020</td>
                                                            <td>Montag</td>
                                                            <td>Kassel – Palma de Mallorca - Kassel</td>
                                                        </tr>
                                                        <tr>
                                                            <td>05.05.2020</td>
                                                            <td>27.10.2020</td>
                                                            <td>Dienstag</td>
                                                            <td>Kassel – Heraklion - Kassel</td>
                                                        </tr>
                                                        <tr>
                                                            <td>06.05.2020</td>
                                                            <td>28.10.2020</td>
                                                            <td>Mittwoch</td>
                                                            <td>Kassel – Palma de Mallorca - Kassel</td>
                                                        </tr>
                                                        <tr>
                                                            <td>07.05.2020</td>
                                                            <td>29.10.2020</td>
                                                            <td>Donnerstag</td>
                                                            <td>Kassel – Rhodos - Kassel</td>
                                                        </tr>
                                                        <tr>
                                                            <td>07.05.2020</td>
                                                            <td>29.10.2020</td>
                                                            <td>Donnerstag</td>
                                                            <td>Kassel – Hurghada - Kassel</td>
                                                        </tr>
                                                        <tr>
                                                            <td>01.05.2020</td>
                                                            <td>30.10.2020</td>
                                                            <td>Freitag</td>
                                                            <td>Kassel – Palma de Mallorca - Kassel</td>
                                                        </tr>
                                                        <tr>
                                                            <td>03.07.2020</td>
                                                            <td>30.10.2020</td>
                                                            <td>Freitag</td>
                                                            <td>Kassel – Fuerteventura - Kassel</td>
                                                        </tr>
                                                        <tr>
                                                            <td>02.05.2020</td>
                                                            <td>31.10.2020</td>
                                                            <td>Samstag</td>
                                                            <td>Kassel – Heraklion - Kassel</td>
                                                        </tr>
                                                        <tr>
                                                            <td>03.05.2020</td>
                                                            <td>25.10.2020</td>
                                                            <td>Sonntag</td>
                                                            <td>Kassel – Palma de Mallorca - Kassel</td>
                                                        </tr>
                                                    </table><br />

                                                    <br /><p>Kontakt: <a href="mailto:Presse@SUNDAIR.com">Presse@SUNDAIR.com</a></p>
                                                </div>
                                                <div class="post-meta">
                                                    <div class="entry-date">
                                                        <label class="date">09.08.</label>
                                                        <label class="month">2019</label>
                                                    </div>
                                                    <div class="entry-author fn">
                                                        <i class="icon soap-icon-user"></i> Veröffentlicht von:
                                                        <a href="#" class="author">SUNDAIR</a>
                                                    </div>
                                                    <div class="entry-action">
                                                        <span class="entry-tags"><i class="soap-icon-features"></i><span><a href="#">News</a>, <a href="#">Infos</a></span></span>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <!-- <a href="#" class="button btn-large full-width">LOAD MORE POSTS</a> -->
                            </div>
                        </div>


                        <!-- Pressmitteilung,19.07.2019 -->
                        <div class="page">
                            <div class="post-content">
                                <div class="blog-infinite">
                                    <div class="post">
                                        <div class="post-content-wrapper">
                                            <figure class="image-container">
                                                <img src="/res/images/banner-sdr/banner_pressrelease_5.jpg" alt="" />
                                            </figure>
                                            <div class="details">
                                                <h2 class="entry-title">SUNDAIR präsentiert Winterziele ab Dresden</h2>
                                                <br />
                                                <div class="excerpt-container">
                                                    <p>
                                                    <b>Stralsund, 19.07.2019 </b> – Anfang Mai startete SUNDAIR erstmals von ihrer neu eröffneten Basis in Dresden mit einem Flug
                                                    auf die griechische Insel Kos. Seither hat die junge Stralsunder Airline mit Heraklion, Rhodos und Antalya weitere Sommerdestinationen
                                                    in ihr Streckennetz aufgenommen. Am 27. Oktober startet der Winterflugplan am Flughafen Dresden und SUNDAIR verbindet die sächsische
                                                    Landeshauptstadt mit den Urlaubszielen Fuerteventura, Gran Canaria, Teneriffa, Hurghada und Marsa Alam. <br /><br />

                                                    Auf den Kanarischen Inseln erwartet die Reisenden ganzjährig angenehme Temperaturen, tolle Landschaften sowie endlos lange Badestrände.
                                                    Mit SUNDAIR erreichen Urlauber ab Dresden je einmal wöchentlich die Insel der Vielfalt Gran Canaria, die Sonneninsel Fuerteventura,
                                                    sowie die größte Insel der Kanaren Teneriffa. Das Rote Meer besticht als Bade- und Tauchparadies vor allem durch die durchgehend
                                                    sommerlichen Temperaturen sowie den traumhaften Stränden und dem türkisblauen Meer. Auch Freunde des Tauchsports kommen beim
                                                    Entdecken der vielfältigen Korallenriffe voll auf ihre Kosten. SUNDAIR fliegt Urlauber im Winterflugplan dreimal wöchentlich von
                                                    Dresden nach Hurghada. Ab Februar 2020 ergänzt je ein wöchentlicher Flug nach Marsa Alam das Destinationsportfolio der Airline in Ägypten.<br /><br />

                                                    <i>„Nach dem sehr guten Start in Dresden seit unserer Stationseröffnung am 1. Mai in diesem Jahr, freuen wir uns auf eine ebenso erfolgreiche Wintersaison am
                                                    Flughafen mit vielen zufriedenen Gästen, die mit SUNDAIR in ihren Urlaub starten. Unser Destinationsportfolio bietet den Reisenden eine breite Vielfalt
                                                    an Möglichkeiten: Von Erholung am Strand bis zu einem Aktivurlaub mit Wanderungen oder Tauchgängen“</i>, so Marcos Rossello, Geschäftsführer der SUNDAIR.<br /><br />

                                                    Götz Ahmelmann, Vorstandsvorsitzender der Mitteldeutschen Flughafen AG und Geschäftsführer der Flughäfen Dresden und Leipzig/Halle, betont:
                                                    <i>„Die Kanaren zählen am Flughafen Dresden seit vielen Jahren zu den beliebtesten Winterzielen. Umso mehr freut es mich, dass nach einer kurzen Unterbrechung Fuerteventura,
                                                    Gran Canaria und Teneriffa wieder im Flugplan stehen. Mit Hurghada und Marsa Alam haben Erholungssuchende zudem zwei sonnenreiche Alternativen, die mit unserem
                                                    Partner SUNDAIR nonstop ab Dresden erreichbar sind.“</i><br /><br />


                                                    <br /><b>SUNDAIR Winterflugplan 2019/2020 ab dem Flughafen Dresden:</b><br />
                                                    <table style="width:100%">
                                                        <tr>
                                                            <td>04.11.2019</td>
                                                            <td>20.04.2020</td>
                                                            <td>Montag</td>
                                                            <td>Dresden – Fuerteventura – Dresden</td>
                                                        </tr>
                                                        <tr>
                                                            <td>05.11.2019</td>
                                                            <td>28.04.2020</td>
                                                            <td>Dienstag</td>
                                                            <td>Dresden – Hurghada – Dresden</td>
                                                        </tr>
                                                        <tr>
                                                            <td>06.11.2019</td>
                                                            <td>15.04.2020</td>
                                                            <td>Mittwoch</td>
                                                            <td>Dresden – Teneriffa – Dresden</td>
                                                        </tr>
                                                        <tr>
                                                            <td>07.11.2019</td>
                                                            <td>30.04.2020</td>
                                                            <td>Donnerstag</td>
                                                            <td>Dresden – Hurghada – Dresden</td>
                                                        </tr>
                                                        <tr>
                                                            <td>07.02.2020</td>
                                                            <td>17.04.2020</td>
                                                            <td>Freitag</td>
                                                            <td>Dresden – Marsa Alam – Dresden</td>
                                                        </tr>
                                                        <tr>
                                                            <td>02.11.2019</td>
                                                            <td>18.04.2020</td>
                                                            <td>Samstag</td>
                                                            <td>Dresden – Hurghada – Dresden</td>
                                                        </tr>
                                                        <tr>
                                                            <td>03.11.2019</td>
                                                            <td>26.04.2020</td>
                                                            <td>Sonntag</td>
                                                            <td>Dresden – Gran Canaria - Dresden</td>
                                                        </tr>
                                                    </table><br />

                                                    <br /><p>Kontakt: <a href="mailto:Presse@SUNDAIR.com">Presse@SUNDAIR.com</a></p>
                                                </div>
                                                <div class="post-meta">
                                                    <div class="entry-date">
                                                        <label class="date">19.07.</label>
                                                        <label class="month">2019</label>
                                                    </div>
                                                    <div class="entry-author fn">
                                                        <i class="icon soap-icon-user"></i> Veröffentlicht von:
                                                        <a href="#" class="author">SUNDAIR</a>
                                                    </div>
                                                    <div class="entry-action">
                                                        <span class="entry-tags"><i class="soap-icon-features"></i><span><a href="#">News</a>, <a href="#">Infos</a></span></span>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <!-- <a href="#" class="button btn-large full-width">LOAD MORE POSTS</a> -->
                            </div>
                        </div>


                        <!-- Pressmitteilung,17.05.2019 -->
                        <div class="page">
                            <div class="post-content">
                                <div class="blog-infinite">
                                    <div class="post">
                                        <div class="post-content-wrapper">
                                            <figure class="image-container">
                                                <img src="/res/images/banner-sdr/banner_pressrelease_4.jpg" alt="" />
                                            </figure>
                                            <div class="details">
                                                <h2 class="entry-title">SUNDAIR präsentiert Flugprogramm ab Bremen</h2>
                                                <br />
                                                <div class="excerpt-container">
                                                    <p>
                                                    <b>Stralsund, 17.05.2019  </b> – Die Stralsunder Fluggesellschaft SUNDAIR stationiert zum Spätsommer
                                                    2019 einen Airbus A320 am Bremen Airport und bietet Gästen in und um Bremen die
                                                    Möglichkeit, bequem in ihren Urlaub zu starten. Der Erstflug ab Bremen findet am 31. August
                                                    2019 statt und bringt Reisende auf die griechische Urlaubsinsel Rhodos. Anschließend werden
                                                    bis zum Beginn des Winterflugplans die beliebten Ferienziele Mallorca, Kreta und Antalya und
                                                    auf den Kanarischen Inseln Gran Canaria und Fuerteventura angeflogen. Ab November startet
                                                    SUNDAIR zweimal wöchentlich nach Hurghada in Ägypten. Ab Februar ergänzt Marsa Alam
                                                    zusätzlich das Destinationsportfolio der Airline am Roten Meer. Ergänzend zum Angebot in
                                                    Ägypten bedient SUNDAIR ebenfalls mit je einem wöchentlichen Flug die beliebten Winterziele
                                                    Teneriffa, Gran Canaria sowie Fuerteventura auf den Kanarischen Inseln. Die spanische
                                                    Ferieninsel Fuerteventura ist zudem ab Februar 2020 mit zwei wöchentlichen Flügen zu
                                                    erreichen. Insgesamt sind bis zu 22 Starts und Landungen pro Woche ab Bremen Airport
                                                    geplant. <br /><br />

                                                    <i>„Wir freuen uns nach Berlin, Kassel und Dresden nun auch in Bremen zu starten und Reisende
                                                    in den Urlaub zu fliegen. Die starke Nachfrage in Bremen hat uns darin bestärkt, unser
                                                    Engagement auch im nächsten Sommer fortzusetzen und weiter auszubauen. Unsere Gäste
                                                    können sich auf tolle Urlaubsziele am Mittelmeer, am Roten Meer sowie am Atlantischen
                                                    Ozean freuen. Dazu gibt es natürlich den guten SUNDAIR Service, den die Kunden von uns
                                                    kennen“</i>, so Marcos Rossello, Geschäftsführer der SUNDAIR.<br /><br />

                                                    Flughafen-Geschäftsführer Elmar Kleinert ergänzt: <i>„Wir freuen uns, mit SUNDAIR eine neue Airline am Bremen Airport im Angebot
                                                    zu haben, die in Bremen ihr Engagement über die kommenden Jahre ausbauen will und bei
                                                    uns ab Herbst ein Flugzeug stationiert. Somit haben wir beispielsweise die Kanarischen Inseln
                                                    ab Spätsommer und auch im kommenden Winterflugplan im Programm.“</i><br /><br />

                                                    <br /><b>SUNDAIR Winterflugplan 2019/2020 ab Bremen Airport:</b><br />
                                                    <table style="width:100%">
                                                        <tr>
                                                            <td>04.11.2019</td>
                                                            <td>20.04.2020</td>
                                                            <td>Montag</td>
                                                            <td>Bremen – Hurghada – Bremen</td>
                                                        </tr>
                                                        <tr>
                                                            <td>05.11.2019</td>
                                                            <td>19.11.2019 </td>
                                                            <td>Dienstag</td>
                                                            <td>Bremen – Antalya – Bremen</td>
                                                        </tr>
                                                        <tr>
                                                            <td>04.02.2020 </td>
                                                            <td>14.04.2020 </td>
                                                            <td>Dienstag</td>
                                                            <td>Bremen – Fuerteventura – Bremen</td>
                                                        </tr>
                                                        <tr>
                                                            <td>06.11.2019 </td>
                                                            <td>15.04.2020 </td>
                                                            <td>Mittwoch</td>
                                                            <td>Bremen – Teneriffa – Bremen</td>
                                                        </tr>
                                                        <tr>
                                                            <td>07.11.2019 </td>
                                                            <td>30.04.2020 </td>
                                                            <td>Donnerstag</td>
                                                            <td>Bremen – Hurghada – Bremen</td>
                                                        </tr>
                                                        <tr>
                                                            <td>01.11.2019 </td>
                                                            <td>22.11.2019</td>
                                                            <td>Freitag</td>
                                                            <td>Bremen – Antalya – Bremen</td>
                                                        </tr>
                                                        <tr>
                                                            <td>07.02.2020 </td>
                                                            <td>17.04.2020 </td>
                                                            <td>Freitag</td>
                                                            <td>Bremen – Marsa Alam – Bremen</td>
                                                        </tr>
                                                        <tr>
                                                            <td>02.11.2019</td>
                                                            <td>25.04.2020</td>
                                                            <td>Samstag</td>
                                                            <td>Bremen – Fuerteventura – Bremen</td>
                                                        </tr>
                                                        <tr>
                                                            <td>03.11.2019 </td>
                                                            <td>19.04.2020 </td>
                                                            <td>Sonntag</td>
                                                            <td>Bremen – Gran Canaria – Bremen</td>
                                                        </tr>
                                                    </table><br />

                                                    <br /><p>Kontakt: <a href="mailto:Presse@SUNDAIR.com">Presse@SUNDAIR.com</a></p>
                                                </div>
                                                <div class="post-meta">
                                                    <div class="entry-date">
                                                        <label class="date">17.05.</label>
                                                        <label class="month">2019</label>
                                                    </div>
                                                    <div class="entry-author fn">
                                                        <i class="icon soap-icon-user"></i> Veröffentlicht von:
                                                        <a href="#" class="author">SUNDAIR</a>
                                                    </div>
                                                    <div class="entry-action">
                                                        <span class="entry-tags"><i class="soap-icon-features"></i><span><a href="#">News</a>, <a href="#">Infos</a></span></span>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <!-- <a href="#" class="button btn-large full-width">LOAD MORE POSTS</a> -->
                            </div>
                        </div>


                        <!-- Pressmitteilung, 01.05.2019 -->
                        <div class="page">
                            <div class="post-content">
                                <div class="blog-infinite">
                                    <div class="post">
                                        <div class="post-content-wrapper">
                                            <figure class="image-container">
                                                <img src="/res/images/banner-sdr/banner_pressrelease_3.jpg" alt="" />
                                            </figure>
                                            <div class="details">
                                                <h2 class="entry-title">Neue Basis in Dresden: SUNDAIR startet Tourismusprogramm</h2>
                                                <br />
                                                <div class="excerpt-container">
                                                    <p>
                                                        <b>Stralsund, 1.Mai 2019 </b> – Mit einer voll besetzten Maschine startete die Stralsunder Airline heute
                                                        erstmals von Dresden auf die griechische Urlaubsinsel Kos. Zeitgleich wurde nach BerlinTegel und Kassel-Calden auch die dritte deutsche Basis von SUNDAIR eröffnet. Unter
                                                        Wasserfontänen der Dresdner Flughafenfeuerwehr verließ der Airbus A320 den Flughafen
                                                        pünktlich um 13.45 Uhr. Die traumhaften Sandstrände und das Mittelmeerklima machen Kos
                                                        in der Sommersaison zu einem attraktiven Urlaubsziel. In rund drei Stunden ist die griechische
                                                        Urlaubsinsel zukünftig jeweils mittwochs und samstags von Dresden erreichbar. Nunmehr
                                                        haben Urlauber aus der sächsischen Landeshauptstadt und ihrem Umland die Möglichkeit,
                                                        ganz bequem in den Urlaub zu starten. Insgesamt sind im Sommerflugplan bis zu 30 Starts
                                                        und Landungen pro Woche ab Dresden geplant. Neben den griechischen Inseln Kos, Kreta
                                                        und Rhodos umfasst der Sommerflugplan der SUNDAIR ebenfalls Antalya in der Türkei.<br /><br />

                                                        <i>„Wir freuen uns, mit dem heutigen Erstflug unsere neue Station zu eröffnen und nun auch vom
                                                        Flughafen Dresden in den Sommerflugplan zu starten. Mit unseren Flügen in Richtung
                                                        Griechenland und in die Türkei bieten wir Urlaubern ein attraktives Reiseportfolio für ihren
                                                        Sommerurlaub“ </i>, so Marcos Rossello, Geschäftsführer der SUNDAIR.<br /><br />

                                                        Götz Ahmelmann, Vorstandsvorsitzender der Mitteldeutschen Flughafen AG und Vorsitzender
                                                        der Geschäftsführung der Flughäfen Dresden und Leipzig/Halle, ergänzt:
                                                        <i>„Ich freue mich, dass SUNDAIR das touristische Angebot an unserem Airport erweitert und
                                                        wünsche unserem Partner allzeit guten Flug.“ </i>
                                                    </p>

                                                    <br />
                                                    <p>Kontakt: <a href="mailto:Presse@SUNDAIR.com">Presse@SUNDAIR.com</a></p>
                                                </div>
                                                <div class="post-meta">
                                                    <div class="entry-date">
                                                        <label class="date">01.05</label>
                                                        <label class="month">2019</label>
                                                    </div>
                                                    <div class="entry-author fn">
                                                        <i class="icon soap-icon-user"></i> Veröffentlicht von:
                                                        <a href="#" class="author">SUNDAIR</a>
                                                    </div>
                                                    <div class="entry-action">
                                                        <span class="entry-tags"><i class="soap-icon-features"></i><span><a href="#">News</a>, <a href="#">Infos</a></span></span>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <!-- <a href="#" class="button btn-large full-width">LOAD MORE POSTS</a> -->
                            </div>
                        </div>


                        <!-- Pressemitteilung, 15.04.2019 -->
                        <div class="page">
                            <div class="post-content">
                                <div class="blog-infinite">
                                    <div class="post">
                                        <div class="post-content-wrapper">
                                            <figure class="image-container">
                                                <img src="/res/images/banner-sdr/banner_pressrelease_2.jpg" alt="" />
                                            </figure>
                                            <div class="details">
                                                <h2 class="entry-title">Sommerflugplan startet am Kassel Airport zum Beginn der Osterferien</h2>
                                                <p><b>SUNDAIR stationiert ein Flugzeug am Flughafen Bremen und schließt weitere Lücken im Flugplan</b></p>
                                                <br />
                                                <div class="excerpt-container">
                                                    <p>
                                                    <b>Kassel, 15. April 2019</b> –– Pünktlich zum Beginn der hessischen Osterferien startet am Kassel
                                                    Airport der Sommerflugplan mit einigen Zielen: Seit dem 14.04 geht es bereits zweimal
                                                    wöchentlich nach Palma/Mallorca (montags und sonntags). Ab Ende April kommen noch
                                                    drei weitere Verbindungen hinzu (mittwochs, donnerstags und freitags). Insgesamt bietet
                                                    die Airline SUNDAIR im Sommer 5 wöchentliche Verbindungen ab Kassel auf die beliebte
                                                    Ferieninsel an.<br /><br />

                                                    Auch Griechenland-Fans kommen bereits jetzt an ihr Ziel und erreichen Heraklion auf
                                                    Kreta seit dem Ferienstart mit SUNDAIR zweimal wöchentlich (dienstags und samstags).<br /><br />

                                                    Ab Mai können Reisende neu mit SUNDAIR bis zu zweimal wöchentlich nach Antalya reisen
                                                    sowie ganzjährig nach Hurghada in Ägypten und Fuerteventura auf den Kanarischen
                                                    Inseln. <br /><br />

                                                    <i>„Wir freuen uns auch in diesem Sommer Urlaubern ab dem Kassel Airport ein attraktives
                                                    Reiseangebot anbieten zu können. Die anhaltende Nachfrage ermöglicht es uns, unseren
                                                    Flugplan um eine zusätzliche Frequenz auf insgesamt fünf wöchentliche Flüge in Richtung
                                                    Palma/Mallorca zu ergänzen. Mit unserer neuen Verbindung nach Antalya erweitern wir
                                                    ebenfalls unsere Streckenvielfalt ab Kassel“</i>, so <b>Marcos Rossello, Geschäftsführer SUNDAIR
                                                    GmbH</b>.<br /><br />

                                                    Sonnenhungrige Nordhessen verlängern jetzt schon ihren Sommer auch im nächsten
                                                    Winter und starten ab Kassel direkt in den Sonnen-Urlaub: Die ersten Angebote für den
                                                    Winter 2019/2020 sind veröffentlicht und buchbar. Mit SUNDAIR geht es von November bis
                                                    April zweimal wöchentlich nach Hurghada/Ägypten (donnerstags und samstags) sowie
                                                    jeweils einmal wöchentlich nach Teneriffa (mittwochs) und Gran Canaria (sonntags).<br /><br />

                                                    <b>Lars Ernst, Geschäftsführer Flughafen GmbH Kassel:</b> <i>„Wir freuen uns sehr, dass die Ziele
                                                    für den kommenden Winter so früh buchbar sind, um den Urlaubern eine langfristige
                                                    Planung zu ermöglichen und das ein oder andere Reise-Schnäppchen zu ergattern. Die
                                                    Reiseziele haben sich im letzten Winter bewährt und wir freuen uns, dass die Nachfrage
                                                    in der Region weiter anhält. Auch im Winter wird somit wieder ein entspannter und
                                                    bequemer Start in den Urlaub direkt ab Kassel möglich sein.“</i><br /><br />

                                                    <b>Der vorläufige Winterflugplan 2019/2020 ab Kassel im Detail:</b>

                                                    <table style="width:100%">
                                                        <tr>
                                                            <td>06.11.19 bis 15.04.20 </td>
                                                            <td>Mittwoch</td>
                                                            <td>Kassel – Teneriffa - Kassel</td>
                                                        </tr>
                                                        <tr>
                                                            <td>07.11.19 bis 30.04.20 </td>
                                                            <td>Donnerstag</td>
                                                            <td>Kassel – Hurghada - Kassel</td>
                                                        </tr>
                                                        <tr>
                                                            <td>02.11.19 bis 25.04.20 </td>
                                                            <td>Samstag</td>
                                                            <td>Kassel – Hurghada - Kassel</td>
                                                        </tr>
                                                        <tr>
                                                            <td>03.11.19 bis 19.04.20  </td>
                                                            <td>Sonntag</td>
                                                            <td>Kassel – Gran Canaria - Kassel</td>
                                                        </tr>
                                                    </table><br />
                                                    Den Flugplan und weitere Informationen finden Sie auch unter <a href="http://www.kassel-airport.aero" target="_new">www.kassel-airport.aero</a><br /><br />
                                                    </p>
                                                    <br />
                                                    <p>Kontakt: <a href="mailto:Presse@SUNDAIR.com">Presse@SUNDAIR.com</a></p>
                                                </div>
                                                <div class="post-meta">
                                                    <div class="entry-date">
                                                        <label class="date">15.04.</label>
                                                        <label class="month">2019</label>
                                                    </div>
                                                    <div class="entry-author fn">
                                                        <i class="icon soap-icon-user"></i> Veröffentlicht von:
                                                        <a href="#" class="author">SUNDAIR</a>
                                                    </div>
                                                    <div class="entry-action">
                                                        <span class="entry-tags"><i class="soap-icon-features"></i><span><a href="#">News</a>, <a href="#">Infos</a></span></span>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <!-- <a href="#" class="button btn-large full-width">LOAD MORE POSTS</a> -->
                            </div>
                        </div>


                        <!-- Pressmitteilung, 13.02.2019 -->
                        <div class="page">
                            <div class="post-content">
                                <div class="blog-infinite">
                                    <div class="post">
                                        <div class="post-content-wrapper">
                                            <figure class="image-container">
                                                <img src="/res/images/banner-sdr/banner_pressrelease_1.jpg" alt="" />
                                            </figure>
                                            <div class="details">
                                                <h2 class="entry-title">Mit SUNDAIR ab Spätsommer 2019 vom Bremen Airport in den Urlaub</h2>
                                                <p><b>SUNDAIR stationiert ein Flugzeug am Flughafen Bremen und schließt weitere Lücken im Flugplan</b></p>
                                                <br />
                                                <div class="excerpt-container">
                                                    <p>
                                                    <b>Stralsund, 13. Februar 2019</b> – Nach Veröffentlichung der Stationierung eines Flugzeuges am
                                                    Flughafen Dresden kündigt die junge deutsche Airline nun eine weitere Basis am Bremen
                                                    Airport an. Mit der Stationierung eines Flugzeuges vom Typ Airbus A320 bietet SUNDAIR den
                                                    Urlaubern aus Bremen und dem angrenzenden Niedersachsen die Möglichkeit bequem in
                                                    ihren Urlaub zu starten. Der Erstflug ab Bremen findet am 31. August auf die griechische Insel
                                                    Rhodos statt. Die Stralsunder Fluggesellschaft startet anschließend ihre Flüge zu den
                                                    Ferienzielen Mallorca, Kreta, Rhodos und Antalya im Mittelmeer sowie Gran Canaria und
                                                    Fuerteventura auf den Kanarischen Inseln. Insgesamt sind für den Spätsommer 22 Starts und
                                                    Landungen pro Woche ab Bremen Airport geplant.<br /><br />
                                                    Marcos Rossello, Geschäftsführer der Airline, freut sich auf den neuen Standort und das
                                                    SUNDAIR nur wenige Jahre nach der Gründung bereits in so vielen Ecken Deutschlands Flagge
                                                    zeigt. <i>„Wir freuen uns, nach dem erfolgreichen Start in Berlin und Kassel, sowie nach der
                                                    Ankündigung unserer Station in Dresden, nun auch Gäste aus dem Norden in ihren Urlaub zu
                                                    befördern und sie von unserem guten Service überzeugen zu können“</i>, so Rossello.<br /><br />
                                                    Alle Pauschalreisen mit SUNDAIR ab Bremen sind ab sofort buchbar.
                                                    </p>

                                                    <br />
                                                    <p>Kontakt: <a href="mailto:Presse@SUNDAIR.com">Presse@SUNDAIR.com</a></p>
                                                </div>
                                                <div class="post-meta">
                                                    <div class="entry-date">
                                                        <label class="date">13.02.</label>
                                                        <label class="month">2019</label>
                                                    </div>
                                                    <div class="entry-author fn">
                                                        <i class="icon soap-icon-user"></i> Veröffentlicht von:
                                                        <a href="#" class="author">SUNDAIR</a>
                                                    </div>
                                                    <div class="entry-action">
                                                        <span class="entry-tags"><i class="soap-icon-features"></i><span><a href="#">News</a>, <a href="#">Infos</a></span></span>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <!-- <a href="#" class="button btn-large full-width">LOAD MORE POSTS</a> -->
                            </div>
                        </div>


                        <!-- Pressmitteilung, 11.02.2019 -->
                        <div class="page">
                            <div class="post-content">
                                <div class="blog-infinite">
                                    <div class="post">
                                        <div class="post-content-wrapper">
                                            <figure class="image-container">
                                               <img src="/res/images/banner-sdr/banner_pressrelease_1.jpg" alt="" />
                                            </figure>
                                            <div class="details">
                                                <h2 class="entry-title">SUNDAIR fliegt für TUI fly</h2>
                                                <br />
                                                <div class="excerpt-container">
                                                    <p>
                                                    <b>Stralsund, 11. Februar 2019</b> – Die junge Fluggesellschaft SUNDAIR startet im Auftrag der TUI fly ab Frühjahr 2019 vom Flughafen Karlsruhe / Baden-Baden (FKB).<br />
                                                    <p>
                                                    Die Stralsunder Airline wird in der diesjährigen Sommersaison ein Flugzeug für TUI fly, der deutschen
                                                    Airline des weltweit führenden Reiseveranstalters TUI, am Flughafen Karlsruhe / Baden-Baden (FKB)
                                                    stationieren. Bei der Maschine handelt es sich um eines der beiden Flugzeuge vom Typ Airbus A319
                                                    mit einer Kapazität von 150 Sitzplätzen, die in diesem Jahr die SUNDAIR Flotte erweitern. Der Flugbetrieb
                                                    ab dem FKB wird am 24. Mai 2019 aufgenommen und umfasst zunächst die komplette Sommersaison
                                                    2019.
                                                    <br /><br />
                                                    <i>„Ab dem Sommer haben TUI Gäste zwischen Schwarzwald und Pfalz wieder direkten Zugang zu den
                                                    schönsten Stränden Griechenlands, der Kanaren, Ägyptens oder Mallorcas. Wir freuen uns mit SUNDAIR
                                                    einen zuverlässigen Partner gefunden zu haben, der mit uns die Sommersonnenziele anfliegen wird“</i>,
                                                    sagt Oliver Lackmann, Geschäftsführer der TUIfly GmbH.
                                                    <br /><br />
                                                    Im Auftrag der TUI fly wird SUNDAIR Urlauber ab Karlsruhe / Baden-Baden (FKB) nach Palma de Mallorca,
                                                    Heraklion, Kos, Rhodos, Hurghada sowie nach Gran Canaria, Fuerteventura und Teneriffa befördern.
                                                    An Bord erwartet die Gäste das gerade erweiterte Cateringangebot der TUI fly, welches neben
                                                    vorbestellbaren Menüs aus dem TUI fly Bistro auch ein breit gefächertes Angebot an Speisen und
                                                    Getränken im TUI fly Café bietet. Weitere Informationen hierzu erhalten Passagiere unter:
                                                    <a href="https://www.tuifly.com/de/service/catering.html" target="_new">https://www.tuifly.com/de/service/catering.html</a>
                                                    </p>

                                                    <br />
                                                    <p>Kontakt: <a href="mailto:Presse@SUNDAIR.com">Presse@SUNDAIR.com</a></p>
                                                </div>
                                                <div class="post-meta">
                                                    <div class="entry-date">
                                                        <label class="date">11.02.</label>
                                                        <label class="month">2019</label>
                                                    </div>
                                                    <div class="entry-author fn">
                                                        <i class="icon soap-icon-user"></i> Veröffentlicht von:
                                                        <a href="#" class="author">SUNDAIR</a>
                                                    </div>
                                                    <div class="entry-action">
                                                        <span class="entry-tags"><i class="soap-icon-features"></i><span><a href="#">News</a>, <a href="#">Infos</a></span></span>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <!-- <a href="#" class="button btn-large full-width">LOAD MORE POSTS</a> -->
                            </div>
                        </div>


                        <!-- Pressmitteilung, 07.02.2019 -->
                        <div class="page">
                            <div class="post-content">
                                <div class="blog-infinite">
                                    <div class="post">
                                        <div class="post-content-wrapper">
                                            <figure class="image-container">
                                                <img src="/res/images/banner-sdr/banner_pressrelease_1.jpg" alt="" />
                                            </figure>
                                            <div class="details">
                                                <h2 class="entry-title">SUNDAIR stellt A320 ab Sommer nach Dresden und schließt große Lücke im Flugplan</h2>
                                                <p><b>Der Flughafen in Sachsen wird zur neuen Basis der jungen Airline</b></p>
                                                <br />
                                                <div class="excerpt-container">
                                                    <p><b>Stralsund, 07. Februar 2019</b> -  – Die plötzliche Germania-Insolvenz hat am Flughafen Dresden eine große Lücke hinterlassen.</p>
                                                    <p>
                                                    SUNDAIR wird ab Sommer 2019 vier frühere Ziele der Airline
                                                    anfliegen und dafür sorgen, dass Urlauber aus Dresden und dem Umland ganz bequem und
                                                    wie geplant in den Sommerurlaub starten können.<br />
                                                    SUNDAIR wird die Passagiere mehrmals
                                                    wöchentlich in die sonnigen Ferienziele Kreta, Rhodos, Kos und Antalya fliegen.<br />
                                                    Insgesamt sind pro Woche 26 Starts und Landungen geplant.
                                                    <br /><br />
                                                    Der Reiseveranstalter schauinsland-reisen, Anteilseigener der SUNDAIR und mit 100-jähriger
                                                    Erfahrung auch für den Vertrieb der Airline verantwortlich, weiß wie wichtig derzeit für alle
                                                    betroffenen Parteien – Reiseveranstalter, Reisebüros, Flughafen und Kunden - die Schaffung
                                                    von „neuen“ Flugverbindungen ist.<br /><br />
                                                    <i>„Wir freuen uns, dass wir gemeinsam mit der SUNDAIR so
                                                    schnell ab Dresden gute und wichtige Verbindungen für die Touristikbranche und die
                                                    Fluggäste anbieten können. Wir sind uns sicher, dass die SUNDAIR mit ihrem guten Service,
                                                    der hohen Pünktlichkeitsquote und dem Freigepäck von 20 kg auch bald in Sachsen zu den
                                                    Lieblingsairlines der Fluggäste gehören wird“</i>, so Gerald Kassner, Geschäftsführer von
                                                    schauinsland-reisen.<br /><br />
                                                    Auch Marcos Rossello, Geschäftsführer der SUNDAIR, zeigt sich erfreut
                                                    über die neue Basis. <i>„Es war uns als neue, deutsche Airline von Anfang an wichtig keine
                                                    Überkapazitäten an irgendeinem Flughafen zu schaffen, sondern Nischen zu bedienen und
                                                    Lücken zu schließen. Mit dem Gang nach Dresden bleiben wir diesem Geschäftsmodell treu
                                                    und werden so weiter wachsen“</i>, so Rossello.
                                                    </p>
                                                    <p>
                                                    Alle Flüge und Pauschalreisen mit SUNDAIR ab Dresden sind ab sofort buchbar.
                                                    </p>
                                                    <br />
                                                    <p>Kontakt: <a href="mailto:Presse@SUNDAIR.com">Presse@SUNDAIR.com</a></p>
                                                </div>
                                                <div class="post-meta">
                                                    <div class="entry-date">
                                                        <label class="date">07.02.</label>
                                                        <label class="month">2019</label>
                                                    </div>
                                                    <div class="entry-author fn">
                                                        <i class="icon soap-icon-user"></i> Veröffentlicht von:
                                                        <a href="#" class="author">SUNDAIR</a>
                                                    </div>
                                                    <div class="entry-action">
                                                        <span class="entry-tags"><i class="soap-icon-features"></i><span><a href="#">News</a>, <a href="#">Infos</a></span></span>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <!-- <a href="#" class="button btn-large full-width">LOAD MORE POSTS</a> -->
                            </div>
                        </div>


                        <!-- Pressmitteilung, 15.01.2019 -->
                        <div class="page">
                            <div class="post-content">
                                <div class="blog-infinite">
                                    <div class="post">
                                        <div class="post-content-wrapper">
                                            <figure class="image-container">
                                                <img src="/res/images/banner-sdr/banner_pressrelease_1.jpg" alt="" />
                                            </figure>
                                            <div class="details">
                                                <h2 class="entry-title">SUNDAIR erweitert die Flotte und wächst auf sechs Maschinen</h2>
                                                <br />
                                                <div class="excerpt-container">
                                                    <p>
                                                        <b>Stralsund, 15. Januar 2019</b> - Die junge Fluggesellschaft SUNDAIR verstärkt auch in diesem Jahr die Flotte um zwei Flugzeuge.<br /><br />
                                                        SUNDAIR erwartet zu Beginn des Sommerflugplans zwei Maschinen vom Typ A319-111.<br /><br />
                                                        Für die beiden Flugzeuge wurde mit der Leasinggesellschaft BBAM ein Vertrag über einen Zeitraum
                                                        von vier Jahren geschlossen.<br /><br />
                                                        Derzeit operieren die beiden Neuzugänge für Sky Airline. Das erste Flugzeug geht bereits Ende Januar in einen planmäßigen Check und wird nach
                                                        derzeitigem Planungsstand voraussichtlich im März die SUNDAIR Flotte ergänzen.<br /><br />
                                                        Der Take-Off des zweiten Flugzeuges ist nach aktuellen Planungen für April vorgesehen.
                                                        Die Stationierung der beiden Maschinen wird zu einem späteren Zeitpunkt bekannt gegeben.
                                                    </p>
                                                    <br />
                                                    <p>Kontakt: <a href="mailto:Presse@SUNDAIR.com">Presse@SUNDAIR.com</a></p>
                                                </div>
                                                <div class="post-meta">
                                                    <div class="entry-date">
                                                        <label class="date">15.01.</label>
                                                        <label class="month">2019</label>
                                                    </div>
                                                    <div class="entry-author fn">
                                                        <i class="icon soap-icon-user"></i> Veröffentlicht von:
                                                        <a href="#" class="author">SUNDAIR</a>
                                                    </div>
                                                    <div class="entry-action">
                                                        <span class="entry-tags"><i class="soap-icon-features"></i><span><a href="#">News</a>, <a href="#">Infos</a></span></span>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <!-- <a href="#" class="button btn-large full-width">LOAD MORE POSTS</a> -->
                            </div>
                        </div>


                        <!-- Pressmitteilung, 14.11.2018 -->
                        <div class="page">
                            <div class="post-content">
                                <div class="blog-infinite">
                                    <div class="post">
                                        <div class="post-content-wrapper">
                                            <figure class="image-container">
                                                <img src="/res/images/banner-sdr/banner_pressrelease_1.jpg" alt="" />
                                            </figure>
                                            <div class="details">
                                                <h2 class="entry-title">Boarding completed for 2018</h2>
                                                <h4>SUNDAIR fliegt mit vier Maschinen</h4>
                                                <br />
                                                <div class="excerpt-container">
                                                    <p>
                                                        <b>Stralsund, 14.November 2018</b> – Die junge Fluggesellschaft SUNDAIR hat im Sommer mit dem Kauf von zwei
                                                        Flugzeugen vom Typ A320-214 ihre Flotte verdoppelt.<br /><br />
                                                        Die dritte Maschine mit der Registrierung D-ASGK ist bereits Ende August in den Flugdienst gestartet. Der vierte Airbus, mit der Kennung D-ASMR,
                                                        wurde am 13. November 2018 in das Luftverkehrsbetreiberzeugnis der SUNDAIR aufgenommen und ist in Berlin-Schönefeld stationiert.
                                                    </p>
                                                    <br />
                                                    <p>Kontakt: <a href="mailto:Presse@SUNDAIR.com">Presse@SUNDAIR.com</a></p>
                                                </div>
                                                <div class="post-meta">
                                                    <div class="entry-date">
                                                        <label class="date">14.11.</label>
                                                        <label class="month">2018</label>
                                                    </div>
                                                    <div class="entry-author fn">
                                                        <i class="icon soap-icon-user"></i> Veröffentlicht von:
                                                        <a href="#" class="author">SUNDAIR</a>
                                                    </div>
                                                    <div class="entry-action">
                                                        <span class="entry-tags"><i class="soap-icon-features"></i><span><a href="#">News</a>, <a href="#">Infos</a></span></span>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <!-- <a href="#" class="button btn-large full-width">LOAD MORE POSTS</a> -->
                            </div>
                        </div>


                        <!-- Pressmitteilung, 05.09.2018 -->
                        <div class="page">
                            <div class="post-content">
                                <div class="blog-infinite">
                                    <div class="post">
                                        <div class="post-content-wrapper">
                                            <figure class="image-container">
                                                <img src="/res/images/banner-sdr/banner_pressrelease_1.jpg" alt="" />
                                            </figure>
                                            <div class="details">
                                                <h2 class="entry-title">Neuer Sommerflugplan 2019 ab Kassel</h2>
                                                <h4>Mit SUNDAIR jetzt auch im Sommer nach Fuerteventura und in die Türkei</h4>
                                                <br />
                                                <div class="excerpt-container">
                                                    <p>
                                                        <b>Stralsund, 05. September 2018</b> – Der neue Sommerflugplan 2019 mit SUNDAIR ab Kassel
                                                        Airport steht größtenteils fest. SUNDAIR fliegt ab Mai nach Mallorca, Kreta, Ägypten und
                                                        ganz neu im Sommer auch nach Fuerteventura und in die Türkei.
                                                    </p>
                                                    <p>
                                                        Die Flüge sind ab sofort im Reisebüro buchbar.
                                                    </p>
                                                    <p>
                                                        Sonnenhungrige Urlauber können sich auf einen abwechslungsreichen Sommerflugplan 2019
                                                        mit neuen Zielgebieten ab Kassel Airport freuen.
                                                    </p>
                                                    <p>
                                                    „Bei dem neuen Sommerflugplan handelt es sich um ein umfangreiches Basisprogramm, das wir frühzeitig für Reisebüros und Kunden
                                                    buchbar machen möchten“, so SUNDAIR-Geschäftsführer Marcos Rossello.<br /><br />
                                                    SUNDAIR fliegt von Mai bis Oktober viermal wöchentlich nach Mallorca (montags, mittwochs,
                                                    freitags, sonntags), zweimal wöchentlich nach Heraklion auf Kreta (dienstags und samstags)
                                                    sowie zweimal wöchentlich nach Hurghada in Ägypten (donnerstags und sonntags).<br /><br />
                                                    Neu im Sommer sind Flüge in die Zielgebiete Fuerteventura (freitags) und zweimal wöchentlich nach Antalya in der Türkei (mittwochs und samstags).
                                                    </p>
                                                    <br />
                                                    <p>Kontakt: <a href="mailto:Presse@SUNDAIR.com">Presse@SUNDAIR.com</a></p>
                                                </div>
                                                <div class="post-meta">
                                                    <div class="entry-date">
                                                        <label class="date">05.09.</label>
                                                        <label class="month">2018</label>
                                                    </div>
                                                    <div class="entry-author fn">
                                                        <i class="icon soap-icon-user"></i> Veröffentlicht von:
                                                        <a href="#" class="author">SUNDAIR</a>
                                                    </div>
                                                    <div class="entry-action">
                                                        <span class="entry-tags"><i class="soap-icon-features"></i><span><a href="#">News</a>, <a href="#">Infos</a></span></span>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <!-- <a href="#" class="button btn-large full-width">LOAD MORE POSTS</a> -->
                            </div>
                        </div>


                        <!-- Pressmitteilung, 13.06.2018 -->
                        <div class="page">
                            <div class="post-content">
                                <div class="blog-infinite">
                                    <div class="post">
                                        <div class="post-content-wrapper">
                                            <figure class="image-container">
                                                <img src="/res/images/banner-sdr/banner_pressrelease_1.jpg" alt="" />
                                            </figure>
                                            <div class="details">
                                                <h2 class="entry-title">Zuwachs: SUNDAIR verdoppelt die Flotte</h2>
                                                <div class="excerpt-container">
                                                    <p>
                                                    <strong>Berlin / Stralsund – 13. Juni 2018</strong> – SUNDAIR hat zwei Flugzeuge vom Typ A320-214 gekauft.
                                                    </p>
                                                    <p>
                                                    Die beiden ehemaligen Maschinen der Air Berlin Gruppe befinden sich derzeit in Budapest, um notwendige Checks zu durchlaufen.
                                                    </p>
                                                    <p>
                                                    Ein Airbus (MSN 2668) war zuletzt unter der Registrierung D-ABHI bekannt. Noch im August soll dieser unter der SUNDAIR-Kennung D-ASGK ab Berlin-Schönefeld operieren.
                                                    </p>
                                                    <p>
                                                    Aufgrund der hohen Nachfrage am Markt wurde entschieden, die Kult-Maschine vorerst mit dem „roten Bauch“ abheben zu lassen und sie zu einem späteren Zeitpunkt in SUNDAIR Farben zu lackieren.
                                                    </p>
                                                    <br /><p>
                                                    Der Take-off für das zweite Flugzeug (MSN 2619) mit der zukünftigen Registrierung D-ASMR ist für September 2018 geplant.
                                                    An welchem Flughafen diese Maschine stationiert wird, ist noch offen.
                                                    </p>
                                                    <br />
                                                    <p>Kontakt: <a href="mailto:Presse@SUNDAIR.com">Presse@SUNDAIR.com</a></p>
                                                </div>
                                                <div class="post-meta">
                                                    <div class="entry-date">
                                                        <label class="date">13.06.</label>
                                                        <label class="month">2018</label>
                                                    </div>
                                                    <div class="entry-author fn">
                                                        <i class="icon soap-icon-user"></i> Veröffentlicht von:
                                                        <a href="#" class="author">SUNDAIR</a>
                                                    </div>
                                                    <div class="entry-action">
                                                        <span class="entry-tags"><i class="soap-icon-features"></i><span><a href="#">News</a>, <a href="#">Infos</a></span></span>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <!-- <a href="#" class="button btn-large full-width">LOAD MORE POSTS</a> -->
                            </div>
                        </div>
                    </div>
                    <!-- End:PagePressReleases -->


                    <!-- Begin:PagePressReleases-Sidebar -->
                    <div class="sidebar col-md-3">
                        <sdr-aboutsundair-box></sdr-aboutsundair-box>
                        <sdr-contact-box></sdr-contact-box>
                    </div>
                    <!-- END:Content-SideBar -->
                </div>
            </div>
        </section>


        <!-- Begin:PromoBox -->
        <sdr-promobox></sdr-promobox>
        <!-- End:PromoBox -->
    </div>
</template>

<script>
    import AboutSundairBox from '../shared/sidebar/AboutSundairBox.vue'; // Sidebar (right)
    import ContactBox from '../shared/sidebar/ContactBox.vue'; // Sidebar (right)
    import PromoBox from '../booking/pagecontent/PromoBox.vue';

    import { mapGetters } from 'vuex';
    import { mapMutations } from 'vuex';
    import { mapActions } from 'vuex';

    export default {

        /* >>> *************************************************************** / /* Components */
        components: {

            'sdr-aboutsundair-box': AboutSundairBox,
            'sdr-contact-box': ContactBox,
            'sdr-promobox': PromoBox,

        }, // eof components{}
        /* <<< ****************************************************************/



        /* >>> *************************************************************** / /* Data */
        data: function() {

            return {
                titleinfo: {
                    en: 'Press releases',
                    de: 'Pressemitteilungen',
                },


                // getCurrentLocale: 'de',
            };

        }, // eof data()
        /* <<< ****************************************************************/



        /* >>> *************************************************************** / /* Computed */
        computed: {

            ...mapGetters([
                'getCurrentLocale',
            ]),

        }, // eof computed{}
        /* <<< ****************************************************************/

    };
</script>

<style scoped>
    /* >>>  iPAD -------------------------------------------------------------*/
    @media only screen
    and (min-device-width : 768px)
    and (max-device-width : 1024px)  {
        h1 {
            font-size: 1.6em;
        }
        h2 {
            font-size: 1.6em;
        }
        .blog-infinite .post .details, .single .post .details {
            padding-top: 20px;
            padding-right: 15px;
            padding-bottom: 10px;
            padding-left: 15px;
        }
    }
</style>


// WEBPACK FOOTER //
// src/components/pressreleases/Home.vue